<template>
  <global-dialog-card v-model="dialog" hide-actions title="">
    <div class="mt-2">
      <div class="mb-4">
        <v-icon>mdi mdi-help-circle-outline</v-icon> {{ $t("support") }}
        <br />
        <a
          href="https://help.ordera.app"
          target="_blank"
          style="text-decoration: none; text-align: left; color: rgb(251, 109, 59)"
        >
          help.ordera.app
        </a>
      </div>
      
      <div class="mb-4">
        <v-icon>mdi mdi-handshake-outline</v-icon>
        {{ $t("corporate_nutrition") }} 
        <br />
        <a
          href="https://topli-obrok.ordera.app"
          target="_blank"
          style="text-decoration: none; text-align: left; color: rgb(251, 109, 59)"
        >
          topli-obrok.ordera.app
        </a>
      </div>
      
      <div class="mb-4">
        <v-icon>mdi mdi-food</v-icon> {{ $t("order_from_home") }} 
        <br />
        <a
          href="https://ordera.app"
          target="_blank"
          style="text-decoration: none; text-align: left; color: rgb(251, 109, 59)"
        >
          ordera.app
        </a>
      </div>
      
      <div class="mb-4">
        <v-icon>mdi mdi-menu</v-icon> {{ $t("digital_menu") }} 
        <br />
        <a
          href="https://konobar.ordera.app/info"
          target="_blank"
          style="text-decoration: none; text-align: left; color: rgb(251, 109, 59)"
        >
          konobar.ordera.app/info
        </a>
      </div>
      
      <div class="mb-2">
        <v-icon>mdi mdi-domain</v-icon>
        {{ $t("become_ordera_partner") }} 
        <br />
        <a
          href="https://partner.ordera.app"
          target="_blank"
          style="text-decoration: none; text-align: left; color: rgb(251, 109, 59)"
        >
          partner.ordera.app
        </a>
      </div>
    </div>
  </global-dialog-card>
</template>

<script>
export default {
  name: "SupportInfoDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>